<template>
  <div>
    <v-container fluid class="mx-0 py-0 white">
      <v-row class="mx-0">
        <v-col lg="2" md="3" cols="12">
          <v-text-field
            dense
            label="Search Text"
            v-model="searchText"
          ></v-text-field>
        </v-col>
        <v-col lg="2" md="3" cols="12">
          <v-select
            :items="filterItems"
            v-model="filterBy"
            label="Filter By"
            dense
          ></v-select>
        </v-col>
        <v-col lg="2" md="3" cols="12">
          <v-select
            :items="eventItems"
            v-model="eventType"
            label="Event"
            dense
          ></v-select>
        </v-col>
        <v-col lg="2" md="3" cols="12">
          <date-time-picker
            :date-time="fromDate"
            v-model.trim="fromDate"
            :label="$t('fields.from_date')"
            :textFieldProps="{ dense: true }"
            timeFormat="HH:mm:ss"
            ref="from_picker"
          ></date-time-picker>
        </v-col>
        <v-col lg="2" md="3" cols="12">
          <date-time-picker
            :date-time="toDate"
            v-model.trim="toDate"
            :textFieldProps="{ dense: true }"
            :label="$t('fields.to_date')"
            timeFormat="HH:mm:ss"
            ref="to_picker"
          ></date-time-picker>
        </v-col>
        <v-col lg="2" md="3" cols="12">
          <div class="my-2">
            <v-btn small color="primary" @click="handleSearchBtn">Search</v-btn>
            <v-btn small color="error" class="mx-1" @click="handleClearBtn"
              >Clear</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DateTimePicker from "@/components/DateTimePicker";

export default {
  components: {
    DateTimePicker
  },
  data() {
    return {
      filterItems: [
        {
          text: "Username",
          value: "username"
        },
        {
          text: "Model type",
          value: "model_type"
        }
      ],
      eventItems: [
        {
          text: "All",
          value: ""
        },
        {
          text: "Created",
          value: "created"
        },
        {
          text: "Updated",
          value: "updated"
        },
        {
          text: "Deleted",
          value: "deleted"
        }
      ],
      filterBy: "username",
      eventType: "",
      searchText: "",
      filterKeys: ["username", "model_type", "event"],
      fromDate: "",
      toDate: "",
      dateFormat: "YYYY-MM-DD HH:mm:ss"
    };
  },
  mounted() {
    this.setQueryValues();
  },
  methods: {
    handleSearchBtn() {
      const queryObj = {};
      if (this.searchText.length > 0) {
        queryObj[this.filterBy] = this.searchText;
      }

      if (this.fromDate) {
        console.log(this.fromDate);
        queryObj.from = this.$moment(this.fromDate).format(this.dateFormat);
      }
      if (this.toDate) {
        console.log(this.toDate);
        queryObj.to = this.$moment(this.toDate).format(this.dateFormat);
      }
      if (this.eventType.length > 0) {
        queryObj.event = this.eventType;
      }
      if (Object.keys(queryObj).length > 0) {
        this.$router.push({ query: queryObj });
      }
    },
    handleClearBtn() {
      this.fromDate = "";
      this.toDate = "";
      this.searchText = "";
      this.eventType = "";
      this.$refs.to_picker.clearHandler();
      this.$refs.from_picker.clearHandler();
      Object.keys(this.$route.query).length > 0
        ? this.$router.push({ query: {} })
        : "";
    },
    setQueryValues() {
      let routerQuery = this.$route.query;
      Object.keys(routerQuery).forEach(key => {
        const filteredKey = this.filterKeys.find(elm => elm === key);
        if (filteredKey) {
          this.filterBy = key;
          this.searchText = routerQuery[key];
        }
      });

      routerQuery.from ? (this.fromDate = routerQuery.from) : "";
      routerQuery.to ? (this.toDate = routerQuery.to) : "";
    }
  }
};
</script>

<style lang="scss" scoped></style>
